import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

const ContextMenu = ({ x, y, onClose, items }) => {
  const menuRef = useRef(null);
  const [style, setStyle] = useState({ top: y, left: x, opacity: 0 });

  // Adjust position to keep menu within viewport
  useEffect(() => {
    if (menuRef.current) {
      const rect = menuRef.current.getBoundingClientRect();
      let newY = y;
      let newX = x;

      if (y + rect.height > window.innerHeight) {
        newY = y - rect.height;
      }
      if (x + rect.width > window.innerWidth) {
        newX = x - rect.width;
      }

      setStyle({ top: newY, left: newX, opacity: 1 });
    }
  }, [x, y]);

  // Close on click outside
  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };
    const handleScroll = () => onClose();

    document.addEventListener('mousedown', handleClick);
    window.addEventListener('scroll', handleScroll, true); // capture phase for scrolling in sub-elements

    return () => {
      document.removeEventListener('mousedown', handleClick);
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      className="filemanager-context-menu"
      style={{
        position: 'fixed',
        zIndex: 9999,
        ...style
      }}
      onContextMenu={(e) => e.preventDefault()}
    >
      <ul className="list-group">
        {items.map((item, index) => (
          item === 'separator' ? (
            <li key={`sep-${index}`} className="list-group-item separator" />
          ) : (
            <li
              key={index}
              className={`list-group-item list-group-item-action ${item.disabled ? 'disabled' : ''}`}
              onClick={() => {
                if (!item.disabled) {
                  item.action();
                  onClose();
                }
              }}
            >
              {item.icon && <i className={`fa ${item.icon} mr-2`} style={{ width: '20px', textAlign: 'center' }} />}
              {item.label}
            </li>
          )
        ))}
      </ul>
    </div>
  );
};

ContextMenu.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string, // 'separator'
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        action: PropTypes.func.isRequired,
        icon: PropTypes.string,
        disabled: PropTypes.bool
      })
    ])
  ).isRequired
};

export default ContextMenu;
